import React from 'react';
import {connect} from 'react-redux';

import { Card, DisplayPercent } from '../';

import {
  setCalculatingTopic,
  setCalculatingCategory
} from '../../actions';

import './calculationcategorycard.css';

const CalculationCategoryCard=({
  category={},
  index,
  errorIds=[],
  onChangeData, // used to detect the sync between "calculating" and its base template

  setCalculatingTopic,
  setCalculatingCategory
})=>{


  // const { relevance=0, topics, result=0, fit=0 } = category;
  const { relevance=0, topics, fit=0 } = category;
  const order = category.order ? category.order : (index+1);
  const name=category.category;
  const _idCat=category._id;
  
  const categoryHasError=errorIds.find(elem=>elem.includes(_idCat)) ? ' category-has-error' : '';



  const onTopicChange=(topicIndex,prop)=>{
    return ({target:{value}})=>{
      const newTopic=topics[topicIndex];
      newTopic[prop]=value;
      setCalculatingTopic(newTopic,index,topicIndex);
      onChangeData(prop);
    }
  }

  const onChangeCategory=(prop)=>{
    return ({target:{value}})=>{
      setCalculatingCategory(index,prop,value);
      onChangeData(prop);
    }
  }


  /*
    category/topic structure from ~/models/calculation.js

      topics: [
        { relevance: 5, topic: "Region", information: "--", score: 0, result: 0 order: 1 }
      ]
  */


  // Category FIT




  const topicsHeader = [
    ['Topic','calculation-card-topic-name-line'],
    ['Information','calculation-card-topic-info-line-header'],
    ['Relevance','calculation-card-topic-relevance-line'],
    ['Score','calculation-card-topic-score-line'],
    ['Result','calculation-card-topic-result-line'],
  ]
  const topicsTHs = topicsHeader.map((elem, index) => <p className={elem[1]} key={'topicsTHS_' + index}>{elem[0]}</p>);



  // Topic rows
  const topicsRows=topics.map((elem,indexTopic)=>{
    const {_id,relevance,topic,information='',score,result=0}=elem;

    /*
      <input className="textfield1 textfield1-small" type="text" onChange={onChangeTopicRelevance(indexTopic)} value={relevance} />
    */


    const hasError = errorIds.find(elem=>(elem[0]===_idCat && elem[1]===_id)) ? ' topic-has-error' : '';

    return (
      <div className={"topic-row"+hasError} key={'cat-topic-' + indexTopic}>
        <p className="calculation-card-topic-name-line">{topic}</p>
        <p className="calculation-card-topic-info-line">
          <input className="textfield1" type="text" onChange={onTopicChange(indexTopic,'information')} value={information} />
        </p>
        <p className="calculation-card-topic-relevance-line">
          <input className="textfield1 textfield1-small" type="text" onChange={onTopicChange(indexTopic,'relevance')} value={relevance} />
        </p>
        <p className="calculation-card-topic-score-line">
          <input className="textfield1 textfield1-small" type="text" onChange={onTopicChange(indexTopic,'score')} value={score} />
        </p>
        <p className="calculation-card-topic-result-line">
          <span className="textfield1 textfield2 textfield1-small textfield-center">{result}</span>
        </p>
      </div>
    )
  });

  return (
    <Card className={"calculation-card font-color2"+categoryHasError}>
      <DisplayPercent className="calc-cat-fit" percent={fit} />
      <div className={"calculation-card-main-title"}>
        <h3>{order}. {name}</h3>
        <p className="category-card-relevance">
          Category relevance to your decision:
          <input className="textfield1 textfield1-small" type="text" onChange={onChangeCategory('relevance')} value={relevance} />
        </p>

        <div className="calculation-card-topics">
          <div className="topic-row topics-header">{topicsTHs}</div>
          {topicsRows}
        </div>
      </div>
    </Card>
  )
}

const mapDispatch2Props=(dispatch)=>({
  setCalculatingTopic:(topic,index,index1)=>dispatch(setCalculatingTopic(topic,index,index1)),
  setCalculatingCategory: (index,prop,value)=>dispatch(setCalculatingCategory(index,prop,value)),
})

export default connect(null,mapDispatch2Props)(CalculationCategoryCard);